import { ReactNode } from 'react'
import { Container } from '../Container'
import { View } from 'reshaped/bundle'

type Props = { children: ReactNode }

export const Hero = ({ children }: Props) => {
	return (
		<View
			backgroundColor="primary"
			paddingTop={10}
			paddingBottom={{ s: 10, m: 20 }}
			attributes={{ style: { background: 'linear-gradient(93deg, #592b86 7%, #3b1c5a 103%)' } }}
		>
			<Container>
				<View paddingBlock={6}>{children}</View>
			</Container>
		</View>
	)
}
